import React from 'react';

import wazeIcon from './waze.png'; // Assuming you have a Waze logo SVG file
import { Box } from '@mui/material';

const WazeAttribution: React.FC = () => (
  <Box
    sx={{
      marginRight: '2px',
    }}
  >
    <Box>Data provided by Waze App</Box>
    <Box display={'flex'} alignItems="center" flexDirection={'row'}>
      <Box>Learn more at</Box>
      <a
        href="https://www.waze.com/"
        target="_blank"
        rel="noopener noreferrer"
        style={{
          marginLeft: 4,
          display: 'flex',
          alignItems: 'center',
          textDecoration: 'none',
        }}
        aria-label="Waze"
      >
        Waze.com
      </a>
      <img
        src={wazeIcon}
        alt="Waze Logo"
        style={{ width: '30px', height: '22px', marginLeft: '3px' }}
      />
    </Box>
  </Box>
);

export default WazeAttribution;
